$(document).ready(function () {

  $(document).on('click', '.template-index.site-header-sticky .site-header-menu-toggle--button', function(){
    $('body,html').scrollTop(0);
  });

  $(document).on("click", '.js--dummyCheckout', function () {
    var $el = $(this),
        $el_wrap = $el.closest('.js--checkout');
    if ($("#agree").is(":checked")) {
      $el_wrap.find('[name="checkout"], [name="goto_pp"], [name="goto_gc"]').click();
    } else {
      alert($el.data('message'));
      return false;
    }
  });

  $(document).on('change', '#agree', function(){
    var $el = $(this),
        $dummy = $('.js--dummyCheckout'),
        $real = $('.real--checkout');
    if($el.prop('checked')) {
      $dummy.addClass('hide');
      $real.removeClass('hide');
      
      $('[name="checkout"], [name="goto_pp"], [name="goto_gc"]').prop('disabled', false)
    } else {
      $real.addClass('hide');
      $dummy.removeClass('hide');
      $('[name="checkout"], [name="goto_pp"], [name="goto_gc"]').prop('disabled', true)
    }
  });
  
  

  $(document).on('click', '.site-mobile-nav--index .navmenu-button', function(){
    var $el = $(this);
    $el.toggleClass('active');
    $el.next().slideToggle();
  });

  $(document).on('click', '.site-header-menu-toggle.index--menu', function(){
    var $el = $(this);
    $el.toggleClass('active');
    if($el.hasClass('active')) {
      $('body').addClass('mobile-menu-open');
    }
    $('.site-mobile-nav--index').slideToggle(function(){
      if(!$el.hasClass('active')) {
        $('body').removeClass('mobile-menu-open');
      }
    });
  });

  $(document).on('click', '.accordion__link', function(){
    var $el = $(this),
        $el_next = $el.next();
    $el.toggleClass('active');
    $el_next.slideToggle();
  });
});